import { useMemo } from "react";
import { Navigate } from "react-router-dom";

import { adminMenu } from "@/components/molecules";
import type { MenuItem } from "@/components/molecules/SideMenu/types";
import { useFilteredAdminMenu } from "@/components/molecules/SideMenu/useFilteredAdminMenu";

import { PATHS } from "./path";

const ICON_SIZE = 16;

const getFirstAccessiblePath = (filteredMenu: MenuItem[]): string => {
  for (const item of filteredMenu) {
    if (item.children?.length) {
      const firstChild = item.children[0];
      if (firstChild.path) return firstChild.path;
    } else if (item.path) {
      return item.path;
    }
  }
  return PATHS.ADMIN.OVERVIEW;
};

const AdminDefaultRedirect = () => {
  const menu = useMemo(() => adminMenu(ICON_SIZE), []);
  const filteredMenu = useFilteredAdminMenu(menu);
  const target = useMemo(
    () => getFirstAccessiblePath(filteredMenu),
    [filteredMenu]
  );

  return <Navigate to={target} replace />;
};

export default AdminDefaultRedirect;
